'use strict';

var _ = require('lodash');
var UserManagementManageAccessRequestsTransformerFactory = function UserManagementManageAccessRequestsTransformerFactory(DataTransformer, UserProcessingTransformationService) {
  function UserManagementManageAccessRequestsTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-management-manage-access-requests-mode';
  }
  UserManagementManageAccessRequestsTransformer.prototype = Object.create(DataTransformer.prototype);
  UserManagementManageAccessRequestsTransformer.constructor = UserManagementManageAccessRequestsTransformer;
  UserManagementManageAccessRequestsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserManagementManageAccessRequestsTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserManagementManageAccessRequestsTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserManagementManageAccessRequestsTransformer.prototype.transform = function (data) {
    return _.map(data.domain.users, function (user) {
      user.userDisplayName = UserProcessingTransformationService.getUserDisplayName(user.userId);
      return user;
    });
  };
  return UserManagementManageAccessRequestsTransformer;
};
UserManagementManageAccessRequestsTransformerFactory.$inject = ['DataTransformerFactory', 'UserProcessingTransformationService'];
module.exports = UserManagementManageAccessRequestsTransformerFactory;